// Оценка изменения «к лучшему / к худшему» и его подпись.

import { formatSigned } from '@/lib/format'

import type { ComparisonRow } from '../api'
import { FIELD_LABELS } from '../labels'

type Better = ComparisonRow['better']

/** true — к лучшему, false — к худшему, null — без оценки или без изменений. */
export function isGood(delta: number | null, better: Better): boolean | null {
  if (delta === null || delta === 0 || better === 'none') return null
  return better === 'up' ? delta > 0 : delta < 0
}

export function toneClass(good: boolean | null): string {
  if (good === null) return 'text-muted'
  return good ? 'text-accent' : 'text-danger'
}

export function deltaText(delta: number, row: Pick<ComparisonRow, 'field' | 'unit'>): string {
  return `${formatSigned(delta, { digits: FIELD_LABELS[row.field].digits })}${row.unit ? ` ${row.unit}` : ''}`
}
